<script setup>
/* eslint-disable vue/no-v-html */
import { computed, ref, onMounted, onUnmounted } from 'vue';
import ConfigurationRadioSelection from '../../ConfigurationRadioSelection';
import { useMainStore } from '../../../store/index.js';

import '../../../styles/configurator-section.css';
import '../../../styles/configurator-selection.css';

const windowWidth = ref(window.innerWidth);

const store = useMainStore();

const emit = defineEmits(['select']);

const props = defineProps({
  items: {
    type: Object,
    default: null,
  },
  images: {
    type: Object,
    required: true,
  },
  isSpecEB: {
    type: Boolean,
    required: true,
  },
  chassisDescriptionKey: {
    type: String,
    required: false,
    default: '',
  },
});

const handleResize = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});

const adas = computed(() => {
  if (!props.items) return null;
  return props.items.find(x => x.id === 'ADAS');
});

const additionalBrake = computed(() => {
  if (!props.items) return null;
  return props.items.find(x => x.id === 'additionalBrake');
});
</script>

<template>
  <section
    v-if="props.items"
    id="chassis"
    class="configurator-section"
  >
    <h2>{{ $i18n('chassisHeaderTitle') }}</h2>
    <div class="flex-row">
      <div class="parent1">
        <img
          :src="props.images.side"
          alt="Truck - side view"
        >
      </div>
      <div
        v-if="props.chassisDescriptionKey"
        class="configurator-section__image-text parent2"
        v-html="$i18n(props.chassisDescriptionKey)"
      />
    </div>
    <template v-if="adas || additionalBrake">
      <div class="configurator-selection">
        <h3>{{ $i18n('safetyHeaderTitle') }}</h3>
        <div class="configurator-section__row">
          <ConfigurationRadioSelection
            v-if="adas"
            v-model="store.selected.chassis[adas.id]"
            :type="adas.id"
            :options="adas.options"
            :title="adas.title"
            :options-container-style="{ height: '100%', 'justify-content': 'center' }"
            @select="emit('select', $event)"
          />
          <template v-if="additionalBrake">
            <div class="sdds-divider-dark-vertical" />
            <ConfigurationRadioSelection
              v-if="additionalBrake"
              v-model="store.selected.chassis[additionalBrake.id]"
              :type="additionalBrake.id"
              :options="additionalBrake.options"
              :title="additionalBrake.title"
              :options-container-style="{ height: '100%', 'justify-content': 'center' }"
              @select="emit('select', $event)"
            />
          </template>
        </div>
      </div>
    </template>
  </section>
</template>

<style scoped>
.sdds-divider-dark-vertical {
  height: var(--sdds-spacing-layout-72);
  margin-top: var(--sdds-spacing-element-48);
  align-self: center;
}

.flex-row {
  display: flex;
  width: 85%;
}

.parent1,
.parent2 {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

.parent1 img {
  max-width: 100%;
  height: auto;
  display: block;
}

@media only screen and (max-width: 1294px) {
  .parent1 img {
    max-width: 80% !important;
  }

  .sdds-divider-dark-vertical {
    display: none;
  }

  .configurator-section__row {
    flex-direction: column;
  }
}

@media only screen and (max-width: 1000px) {
  .flex-row {
    flex-direction: column;
  }

  .parent1 img {
    max-width: 70% !important;
  }
}
</style>
